// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './assets/lang'
import Api from './config/api';
import store from './store/store';
import settings from './request/settings'
import vueResource from 'vue-resource';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Message } from "element-ui";
import VueClipboard from 'vue-clipboard2';
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
// element ui引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//自定义组件无需注册组件
// import '@/tradcomponents/index.js';

Vue.use(ElementUI);
Vue.use(vueResource);
Vue.use(VueClipboard);

//是否要手机号
Vue.prototype.oNphone = true;
Vue.prototype.api = Api;
Vue.prototype.rootHost = settings.VUE_APP_SERVER; //BIPPAX
Vue.prototype.host = settings.VUE_APP_SERVER; //BIPPAX
Vue.prototype.hostws = settings.WSHOST; //BIPPAX
Vue.prototype.$Message = Message;
Vue.http.options.credentials = true;
Vue.http.options.emulateJSON = true;
Vue.http.options.headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  'Content-Type': 'application/json;charset=utf-8'
};
Vue.prototype.getusd = function (originVals, fractionDigits) {
  return originVals ? originVals.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping: true,
  }) : originVals;
};
Vue.prototype.convertToHTMLUnicode = function () {
  var codes = this.$store.getters.usdtList.displaySymbol ? this.$store.getters.usdtList.displaySymbol.split(",") : [];
  var htmlCodes = [];
  for (var i = 0; i < codes.length; i++) {
    var unicode = codes[i].trim();
    htmlCodes.push("&#x" + unicode + ";");
  }
  return htmlCodes.join("");
};
Vue.prototype.getTimezone4K = function () {
  var curlang = this.$store.getters.lang;
  if (curlang == "en_US") {
    return "America/New_York"
    // return "America/Caracas";
  }
  if (curlang == "ja_JP") {
    return "Asia/Tokyo";
  }
  if (curlang == "ko_KR") {
    return "Asia/Seoul";
  }
  if (curlang == "de_DE") {
    return "Europe/Berlin";
  }
  if (curlang == "fr_FR") {
    return "Europe/Paris";
  }
  if (curlang == "ru_RU") {
    return "Europe/Moscow";
  }
  if (curlang == "it_IT") {
    return "Europe/Rome";
  }
  if (curlang == "es_ES") {
    return "Europe/Madrid";
  }
  if (curlang == "zh_HK") {
    return "Asia/Hong_Kong";
  }
  if (curlang == "zh_CN") {
    return "Asia/Shanghai";
  }
  if (curlang == "en_IN") {
    return "Asia/Kolkata";
  }
  if (curlang == "it_CH") {
    return "Asia/Bangkok";
  }
  if (curlang == "pt_PT") {
    return "Europe/Lisbon";
  }
  if (curlang == "ar_SA") {
    return "Asia/Riyadh";
  }
  return curlang;
};
Vue.prototype.getLang4K = function () {
  var curlang = this.$store.getters.lang;
  if (curlang == "en_US") {
    return "en";
  }
  if (curlang == "ja_JP") {
    return "ja";
  }
  if (curlang == "ko_KR") {
    return "ko";
  }
  if (curlang == "de_DE") {
    return "de_DE";
  }
  if (curlang == "fr_FR") {
    return "fr";
  }
  if (curlang == "ru_RU") {
    return "ru";
  }
  if (curlang == "it_IT") {
    return "it";
  }
  if (curlang == "es_ES") {
    return "es";
  }
  if (curlang == "zh_HK") {
    return "zh_TW";
  }
  if (curlang == "zh_CN") {
    return "zh";
  }
  if (curlang == "en_IN") {
    return "in";
  }
  if (curlang == "it_CH") {
    return "ch";
  }
  if (curlang == "pt_PT") {
    return "pt";
  }
  if (curlang == "ar_SA") {
    return "ar";
  }
  return curlang;
};
// Vue.prototype.getndata = function (tick) {
//   const dt = new Date(tick)
//   const y = dt.getFullYear()
//   const m = (dt.getMonth() + 1 + '').padStart(2, '0')
//   const d = (dt.getDate() + '').padStart(2, '0')
//   const hh = (dt.getHours() + '').padStart(2, '0')
//   const mm = (dt.getMinutes() + '').padStart(2, '0')
//   const ss = (dt.getSeconds() + '').padStart(2, '0')
//   return this.$store.getters.lang == 'zh_CN' ? `${y}-${m}-${d} ${hh}:${mm}:${ss}` : `${m}/${d}/${y} ${hh}:${mm}:${ss}`
// };
function toFloor(number, scale = 8) {
  if (new Number(number) == 0) {
    return 0;
  }
  var __str = number + "";
  if (__str.indexOf('e') > -1 || __str.indexOf('E') > -1) {
    var __num = new Number(number).toFixed(scale + 1),
      __str = __num + "";
    return __str.substring(0, __str.length - 1);
  } else if (__str.indexOf(".") > -1) {
    if (scale == 0) {
      return __str.substring(0, __str.indexOf("."));
    }
    return __str.substring(0, __str.indexOf(".") + scale + 1);
  } else {
    return __str;
  }
}
Vue.prototype.timeFormat = function (ticks) {
  let tick = Number(ticks)
  // return momentTimezone(tick).tz(this.getndata(tick)).format("HH:mm:ss");
  const dt = new Date(tick)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${hh}:${mm}:${ss}`
};
Vue.prototype.dateFormat = function (ticks) {
  let tick = Number(ticks)
  const dt = new Date(tick)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return this.$store.getters.lang == 'zh_CN' ? `${y}-${m}-${d} ${hh}:${mm}:${ss}` : `${m}/${d}/${y} ${hh}:${mm}:${ss}`
  // return momentTimezone(tick).tz(this.getndata(tick)).format("YYYY-MM-DD HH:mm:ss")
};
Vue.filter('toFloor', (number, scale) => {
  return toFloor(number, scale);
});
// Vue.prototype.optionsNameFormat = function (tick) {
//   return momentTimezone(tick).tz(this.getndata(tick)).format("MM-DD HH:mm:ss");
// };
// Vue.prototype.dateFormatFromString = function (tick) {
//   var timestamp = momentTimezone(tick).tz('Asia/Shanghai').valueOf();
//   return this.getLang4K() == 'zh' ? momentTimezone(timestamp).tz(this.getndata(tick)).format("YYYY-MM-DD HH:mm:ss") : momentTimezone(timestamp).tz(this.getndata(tick)).format("MM/DD/YYYY HH:mm:ss");
// };
// Vue.prototype.echartsFormat = function (tick) {
//   var timestamp = momentTimezone(tick).tz('Asia/Shanghai').valueOf();
//   return momentTimezone(timestamp).tz(this.getndata(tick)).format("HH:mm");
// };
Vue.filter('dateFormat', function (ticks) {
  let tick = Number(ticks)
  return moment(tick).format("YYYY-MM-DD HH:mm:ss");
});
Vue.prototype.toFloor = toFloor;
Vue.filter('timeFormat', function (ticks) {
  let tick = Number(ticks)
  return moment(tick).format("HH:mm:ss");
});
Vue.http.interceptors.push((request, next) => {
  //登录成功后将后台返回的TOKEN在本地存下来,每次请求从sessionStorage中拿到存储的TOKEN值
  request.headers.set('x-auth-token', localStorage.getItem('TOKEN'));
  let lang = localStorage.getItem('LANGUAGE');
  if (lang != null) {
    lang = lang.substr(1);
    lang = lang.substr(0, lang.length - 1);
  } else {
    lang = 'en_US'
  }
  request.headers.set('lang', lang);

  next((response) => {
    // //登录极验证时需获取后台返回的TOKEN值
    // var xAuthToken = response.headers.get('x-auth-token');
    // if (xAuthToken != null && xAuthToken != '') {
    //   console.log('获取极验证时', xAuthToken);
    //   localStorage.setItem('TOKEN', xAuthToken);
    // }
    if (response.data.code == '4000'
      //  || response.data.code == '3000'
      ) {
      store.commit('setMember', null);
      router.push('/login');
      return false;
    }
    return response;
  });
});

router.beforeEach((to, from, next) => {
  // 获取本地存储的登录状态
  var isLogins = JSON.parse(localStorage.getItem('MEMBER'))
  if (isLogins) { // 已登录
    if (to.path == '/login' || to.path == '/register' || to.path == '/findPwd') { // 如果目标路径是登录页面
      next('/'); // 跳转到首页 
    } else {
      next(); // 继续
    }
  } else { // 未登录
    next(); // 直接通行
    // if (whiteList.indexOf(to.path) !== -1) { // 目标路径在白名单中
    //   next(); // 直接通行
    // } else {
    //   next(); // 重定向到登录页面
    // }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n,
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js